import React from "react";
import {
  sidePartOne,
  sidePartTwo,
  sidePartThree,
  sidePartFour,
} from "../sidebarItems";
import logo from "../logo.svg";
import { Link } from 'react-router-dom';

const Sidebar = () => {
  console.log(sidePartOne);
  return (
    <div className="col-lg-2 col-md-12">
      <div className="sidebar">
        <Link to='/'>
          <img src={logo} alt="" className="logo" />
        </Link>
        <ul className="sidebar-menu">
          {sidePartOne.map((item, index) => {
            const { name, icon } = item;
            return (
              <li className="sidebar-menu__items" key={index}>
                <a href={name.replace(" ", "-").toLowerCase()}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    dangerouslySetInnerHTML={{ __html: icon }}
                    className="sidebar-menu__icons"
                  />

                  {name}
                </a>
              </li>
            );
          })}
        </ul>
        <ul className="sidebar-menu">
          {sidePartTwo.map((item, index) => {
            const { name, icon } = item;
            return (
              <li className="sidebar-menu__items" key={index}>
                <a href={name.replace(" ", "-").toLowerCase()}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    dangerouslySetInnerHTML={{ __html: icon }}
                    className="sidebar-menu__icons"
                  />
                  {name}
                </a>
              </li>
            );
          })}
        </ul>
        <ul className="sidebar-menu">
          {sidePartThree.map((item, index) => {
            const { name, icon } = item;
            return (
              <li className="sidebar-menu__items" key={index}>
                <a href={name.replace(" ", "-").toLowerCase()}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    dangerouslySetInnerHTML={{ __html: icon }}
                    className="sidebar-menu__icons"
                  />
                  {name}
                </a>
              </li>
            );
          })}
        </ul>
        <ul className="sidebar-menu">
          {sidePartFour.map((item, index) => {
            const { name, icon } = item;
            return (
              <li className="sidebar-menu__items" key={index}>
                <a href={name.replace(" ", "-").toLowerCase()}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    dangerouslySetInnerHTML={{ __html: icon }}
                    className="sidebar-menu__icons"
                  />
                  {name}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
